import * as React from 'react';
import { CustomSubmitButton, CustomButton, ButtonType, Modal, ModalFooter, ModalSize, ModalBody, Form } from "soprasteria-ui-library";
import { IReferralResponseModel } from '../../../../models/IReferral';

interface IReferralCloseModal {
    canCloseReferralAsSysAdmin: boolean;
    closeReferral: (data: IReferralResponseModel) => void;
    closeReferralAsSysAdmin: (data: IReferralResponseModel) => void
    isSubmitting: boolean;
}

export const ReferralCloseModal: React.FunctionComponent<IReferralCloseModal> = ({ canCloseReferralAsSysAdmin, closeReferral, closeReferralAsSysAdmin, isSubmitting }) => {

    return (
        <Modal id="close-referral-modal" modalSize={ModalSize.normal} header="Avsluta specialistremiss">
            <ModalBody>
                <p className="text-left">När du skickar remissvar kommer du samtidigt att avsluta specialistremissen. Ingen vård utförd efter avslutningsdatum kommer att kunna rapporteras.</p>
            </ModalBody>
            <ModalFooter>
                <CustomButton buttonType={ButtonType.general} buttonText="Stäng" data-dismiss="modal" id="close-close-referral-modal" />
                <CustomSubmitButton onButtonSubmit={canCloseReferralAsSysAdmin ? closeReferralAsSysAdmin : closeReferral} isLoading={isSubmitting}>Skicka remissvar och avsluta specialistremiss</CustomSubmitButton>
            </ModalFooter>
        </Modal>
    )
}